import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import moment from "moment";
import global_ from "./views/Global";
import "weui";
import pkgObj from "../package.json";
import * as dict from "stfts-dict";
import './assets/font';
import "./assets/plugin/ztree/js/jquery-3.3.1.min.js";
import "./assets/plugin/ztree/js/jquery.ztree.core.js";
import "./assets/plugin/ztree/js/jquery.ztree.excheck.js";
import "./assets/plugin/ztree/js/jquery.ztree.exedit.js";
import "./assets/style/ehrapp.css";

import VueUeditorWrap from 'vue-ueditor-wrap';
Vue.component('vue-ueditor-wrap', VueUeditorWrap);


/*if (process.env.NODE_ENV !== 'production') {
  let mockPlugin = require('./mock/index')
  Vue.use(mockPlugin)
}*/

Vue.use(ElementUI);
Vue.prototype.axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.GLOBAL = global_;

Vue.config.productionTip = false;

dict.init(pkgObj.client_id);

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js